<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '72rem', maxWidth: '94vw'}"
  [header]="'project.steps.providerResults.individual.title' | transloco: titleParams()"
  data-testid="rfp-individual-results-modal"
>
  @if (visible()) {
    @if (results(); as results) {
      <div class="flex flex-col gap-6">
        @if (results.total; as total) {
          <app-rfp-total-summary [total]="total" />
        }

        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <app-rfp-highlight-list
            titleKey="project.steps.providerResults.rfpIndividual.strengths"
            icon="pi pi-arrow-up text-green"
            [items]="results.strengths"
            data-testid="rfp-individual-strengths"
          />
          <app-rfp-highlight-list
            titleKey="project.steps.providerResults.rfpIndividual.weaknesses"
            icon="pi pi-arrow-down text-red"
            [items]="results.weaknesses"
            data-testid="rfp-individual-weaknesses"
          />
        </div>

        <p-accordion [multiple]="true">
          @for (criterion of results.criteria; track criterion.ecNumber) {
            <p-accordion-panel
              [value]="criterion.ecNumber"
              [attr.data-testid]="'rfp-individual-criterion-' + criterion.ecNumber"
            >
              <p-accordion-header>
                <app-rfp-criterion-header [criterion]="criterion" />
              </p-accordion-header>
              <p-accordion-content>
                <app-rfp-sub-criteria-list [criterion]="criterion" />
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>

        <span class="text-muted-color text-xs">{{
          'project.steps.providerResults.rfpIndividual.hint' | transloco
        }}</span>
      </div>
    }
  }
</p-dialog>
